import { useState, useEffect } from "react";
import { Link, useLocation } from 'react-router-dom';
import { Row, Col, Drawer, Menu, Dropdown } from "antd";
import Container from "../../common/Container";
import { HashLink } from 'react-router-hash-link';
import { SvgIcon } from "../../common/SvgIcon";
import { Button } from "../../common/Button";
import About from "../../content/About.json";
import Partner from "../../content/Partner.json";
import OurCustomer from "../../content/OurCustomers.json";
import Service from "../../content/Services.json";
import Contact from "../../content/Contact.json";
import Network from "../../content/Network.json";
import Sbc from "../../content/Sbc.json";
import Busines from "../../content/Business.json";
import Crm from "../../content/Crms.json";
import Uncc from "../../content/Ucncc.json";
import { FaGlobe, FaChevronDown } from "react-icons/fa";

import axios from 'axios';
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
  Menus,
} from "./styles";
import { Helmet } from "react-helmet-async";
import { withTranslation } from "react-i18next";
import i18next from "i18next";


const Header = ({ t }: any) => {
  const URL = process.env.REACT_APP_URL;
  const location = useLocation();
  const currentUrl = `${URL}${location.pathname}`;
  const [visible, setVisibility] = useState(false);
  const [productList, setProductList] = useState([]);
  const storedLang = localStorage.getItem("lang");
  const [lang, setLang] = useState<"en" | "id">(
    storedLang === "id" ? "id" : "en"
  );

  useEffect(() => {
    i18next.changeLanguage(lang);
  }, [lang]);

  const changeLanguage = (newLang: "en" | "id") => {
    localStorage.setItem("lang", newLang);
    setLang(newLang);
    window.location.reload();
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://api.whnmandiri.co.id/products');
        setProductList(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  const showDrawer = () => {
    setVisibility(!visible);
  };

  const onClose = () => {
    setVisibility(false);
  };

  const pageData: Record<string, any> = {
    "/aboutus": About[lang],
    "/partners": Partner[lang],
    "/ourcustomer": OurCustomer[lang],
    "/services": Service[lang],
    "/contact": Contact[lang],
    "/networks": Network[lang]?.[0], 
    "/session-border-controler": Sbc[lang]?.[0],
    "/business-process-ticketing": Busines[lang]?.[0],
    "/customer-relationship-management": Crm[lang]?.[0],
    "/unified-communication-contact-center": Uncc[lang]?.[0],
  };

  const getPageMetaData = (pathname: string) => {
    const data = pageData[pathname] || { title: "" };

    return {
      title: data.title ? `${data.title} | PT. Wahana Mandiri Sydratama` : "PT. Wahana Mandiri Sydratama",
      description: data.text || "PT. Wahana Mandiri Sydratama is a private company providing communication systems, contact centers, and business solutions.",
      imageContent: data.image || `${URL}/img/images/logo_whn.png`
    };
  };


  const { title, description, imageContent } = getPageMetaData(location.pathname);

  const HelmetContent = () => {
    return (
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta httpEquiv="Content-Language" content="en-US" />
        <meta content="width=device-width, initial-scale=1, user-scalable=no" name="viewport" />
        <meta content="IE=edge,chrome=1" httpEquiv="X-UA-Compatible" />
        <meta name="robots" content="index,no-follow" />
        <meta name="author" content="PT. Wahana Mandiri Sydratama" />
        <link rel="canonical" href={currentUrl} />
        <meta name="google-site-verification" content="kScnfxzDzIzcezMGMsBDa65PlUqwmsYqrqyNvRGMlJk" />
        <meta property="og:type" content="company" />
        <meta property="og:image" content={imageContent} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:site_name" content="PT. Wahana Mandiri Sydratama" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={imageContent} />
        <meta name="pinterest-rich-pin" content="true" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
    );
  };

  

  const ourCompanyMenu = (
    <Menu style={{ padding: 0, margin: 0 }}>
      <Menu.Item>
        <Link to="/aboutus" onClick={onClose}>
          <Span>{t("About Us")}</Span>
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link to="/partners" onClick={onClose}>
          <Span>{t("Partners")}</Span>
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link to="/ourcustomer" onClick={onClose}>
          <Span>{t("Our Customer")}</Span>
        </Link>
      </Menu.Item>
    </Menu>
  );

  const solutionMenu = (
    <Menu style={{ padding: 0, margin: 0 }}>
      <Menu.SubMenu 
        style={{ padding: 0, margin: 0 }}
        title={<Span>{t("Unified Communication & Contact Center")}</Span>}
      >
        <Menu.Item >
          <Link to="/unified-communication-contact-center?tab=avaya" onClick={onClose}>
            <Span>{t("AVAYA")}</Span>
          </Link>
        </Menu.Item>
        <Menu.Item >
          <Link to="/unified-communication-contact-center?tab=cisco" onClick={onClose}>
            <Span>{t("CISCO")}</Span>
          </Link>
        </Menu.Item>
        <Menu.Item >
          <Link to="/unified-communication-contact-center?tab=verint" onClick={onClose}>
            <Span>{t("VERINT")}</Span>
          </Link>
        </Menu.Item>
        <Menu.Item >
          <Link to="/unified-communication-contact-center?tab=nxai" onClick={onClose}>
            <Span>{t("NXAI")}</Span>
          </Link>
        </Menu.Item>
        <Menu.SubMenu title={<Span>{t("SMART CENTER")}</Span>}>
          <Menu.Item>
            <Link to="/unified-communication-contact-center?tab=smart-tariff" onClick={onClose}>
              <Span>{t("SMART TARIFF")}</Span>
            </Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="/unified-communication-contact-center?tab=smart-recording" onClick={onClose}>
              <Span>{t("SMART RECORDING")}</Span>
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
      </Menu.SubMenu>

      <Menu.Item >
        <Link to="/customer-relationship-management" onClick={onClose}>
          <Span>{t("Customer Relationship Management")}</Span>
        </Link>
      </Menu.Item>
      <Menu.SubMenu
        style={{ padding: 0, margin: 0 }}
        title={<Span>{t("Business Process & Ticketing")}</Span>}
      >
        <Menu.Item >
          <Link to="/business-process-ticketing?tab=service-desk" onClick={onClose}>
            <Span>{t("Service Desk")}</Span>
          </Link>
        </Menu.Item>
        <Menu.Item >
          <Link to="/business-process-ticketing?tab=ordering-management-system" onClick={onClose}>
            <Span>{t("Ordering Management System")}</Span>
          </Link>
        </Menu.Item>
      </Menu.SubMenu>
      <Menu.SubMenu
        style={{ padding: 0, margin: 0 }}
        title={<Span>{t("Session Border Controler (SBC)")}</Span>}
      >
        <Menu.Item >
          <Link to="/session-border-controler?tab=oracle" onClick={onClose}>
            <Span>{t("ORACLE")}</Span>
          </Link>
        </Menu.Item>
        <Menu.Item >
          <Link to="/session-border-controler?tab=synway" onClick={onClose}>
            <Span>{t("Synway")}</Span>
          </Link>
        </Menu.Item>
      </Menu.SubMenu>
      <Menu.Item >
        <Link to="/networks" onClick={onClose}>
          <Span>{t("Networks")}</Span>
        </Link>
      </Menu.Item>
    </Menu>
  );

  const businessMenu = (
    <Menu style={{ padding: 0, margin: 0 }}>
      <Menu.Item >
        <Link to="/services" onClick={onClose}>
          <Span>{t("Service Desk")}</Span>
        </Link>
      </Menu.Item>
      <Menu.Item >
        <Link to="/services" onClick={onClose}>
          <Span>{t("Ordering Management System")}</Span>
        </Link>
      </Menu.Item>
    </Menu>
  );

  const languageMenu = (
    <Menu onClick={onClose}>
      <Menu.Item onClick={() => changeLanguage("en")} >
        <Span>{t("English")}</Span>
      </Menu.Item>
      <Menu.Item onClick={() => changeLanguage("id")} >
        <Span>{t("Bahasa Indonesia")}</Span>
      </Menu.Item>
    </Menu>
  );

  const MenuItem = () => {
    return (
      <>
        
        <CustomNavLinkSmall>
          <Dropdown overlay={ourCompanyMenu} autoAdjustOverflow placement="bottom">
            <Span>{t("Our Company")}</Span>
          </Dropdown>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall>
          <Dropdown overlay={solutionMenu} autoAdjustOverflow placement="bottom">
            <Span>{t("Solution")}</Span>
          </Dropdown>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall>
          <Link to="/services" onClick={onClose}>
            <Span>{t("Services")}</Span>
          </Link>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall>
          <Link to="/contact" onClick={onClose}>
            <Span>{t("Contact")}</Span>
          </Link>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall>
          <Dropdown overlay={languageMenu} placement="bottom">
            <Span>
              <FaGlobe style={{ fontSize: "14px", margin: "0", padding: "0" }} />
               {t(lang.toUpperCase())}
              <FaChevronDown style={{ fontSize: "14px", margin: "0", padding: "0" }} />
            </Span>
          </Dropdown>
        </CustomNavLinkSmall>
      </>
    );
  };


  return (
    <>
    <HelmetContent/>
    <HeaderSection>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <SvgIcon src="logo_whn.png" width="" height="40px" />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={showDrawer}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} visible={visible} onClose={onClose}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={onClose}>
              <Col span={12}>
                <Menus>Menu</Menus>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
    </>
  );
};

export default withTranslation()(Header);
